import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Requests Vehicle Groups to be assigned to a specific Map Set
 * @param id The ID of the Map Set who is being assigned to
 * @param vehicleGroupIds The IDs of the Vehicle Groups being assigned
 * @returns Data object containing array of assigned Vehicle Group's IDs
 */
export function postMapSetsVehicleGroupsAssign(
  this: unknown,
  id: number,
  vehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).mapSetsVehicleGroupsAssignUrl(id),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(vehicleGroupIds),
        }
      )
    )
  ).pipe(selectData(fleetMessageSchema.extend({ data: z.array(z.number()) })));
}
